import { Box, Button, Grid, Modal, Step, StepLabel, Stepper } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import React, { FormEvent, useState } from 'react'
import { getAuthContainer } from '../../container/auth-modules'
import { AuthService } from '../../modules/auth/services/AuthService'
import { AUTH_SERVICE_KEY } from '../../modules/auth'
import { ResultPatientDataDTO } from '../../modules/script-executions/models/ResultPatientData'
import { FirstStep } from './FirstStep'
import { forkJoin } from 'rxjs'
import { getFileContainer } from '../../container/file-module'
import { FILE_SERVICE_KEY } from '../../modules/files'
import { FileService } from '../../modules/files/services/FileService'
import { SecondStep } from './SecondStep'
import { FormAction, FormActions } from '../../common/utils/form-generation'
import { commonStyles } from '../../common/styles/Styles'
import { AnalysisInmonucompatibility } from 'modules/analysis/models/AnalysisInmonucompatibility'
import { Permission } from 'common/enums/Permissions'
import { COLOR_PRIMARY } from 'routes/color-constants'
import { useStyles } from './Immunocom.styles'
import { URL_INMUNOCOM_TABLE, URL_RECEPTIVENESS_TABLE } from 'routes/routes-constants'
import { navigate } from '@reach/router'

const steps = ['checks', 'analysis']

export type FileType = {
  id: string
  name: string
  ionCode?: string  // IonCode/BarcodeID asociado
  type?: 'sequence' | 'alignment' |  'summary'
}

const fileService = getFileContainer().get<FileService>(FILE_SERVICE_KEY)
const authService = getAuthContainer().get<AuthService>(AUTH_SERVICE_KEY)

export const Form = () => {
  const styles = commonStyles()
    const classes = useStyles({ color: COLOR_PRIMARY })
  
  const { t } = useTranslation()
  const [currentStep, setCurrentStep] = useState<number>(0)
  const [resultPatientList, setResultPatientList] = useState<ResultPatientDataDTO[]>([])
  const [fileTypes, setFileTypes] = useState<FileType[]>([])
  const [selectedClinic, setSelectedClinic] = useState<string>('')
  const [open, setOpen] = useState<boolean>(false)

  const increaseStep = () => {
    setCurrentStep(currentStep + 1)
}
  const deleteFiles = (e: FormEvent) => {
    e.preventDefault()
    forkJoin(fileTypes.map((f) => fileService.delete(f.id))).subscribe(() => {
      setOpen(false)
      setCurrentStep(0)
    })
  }
    
  const goToTable = () => navigate(URL_INMUNOCOM_TABLE)
  
  const actionsDelete: FormAction[] = [
    {
      label: t('close'),
      handleAction: () => setOpen(false),
    },
  ]

  return (
    <Grid container spacing={2}>
        {authService.userCan(Permission.seeResultsRegister) && (
        <Grid item xs={12}>
          <Button
            className={classes.button}
            onClick={goToTable}
            variant={'contained'}
            style={{ float: 'right' }}>
            {t('seeRegister')}
          </Button>
        </Grid>
      )}
      <Grid item xs={12}>
        <Stepper activeStep={currentStep}>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{t(label)}</StepLabel>
            </Step>
          ))}
        </Stepper>
      </Grid>

      {currentStep === 0 && (
        <FirstStep
          increaseStep={increaseStep}
          files={setFileTypes}
          valuesToTable={setResultPatientList}
          selectedClinic={setSelectedClinic}
        />
      )}

      {currentStep === 1 && (
        <SecondStep
          filesGroup={fileTypes}
          clinicID= {selectedClinic}
          patients= {resultPatientList}
          resetSteps={() => setCurrentStep(0)}
        />
      )}

      <Modal open={open}>
        <Box className={styles.modal}>
          <form onSubmit={deleteFiles}>
            <Box mt={2} textAlign={'justify'}>
              {t('cancelinmunocompatibility')}
            </Box>
            <FormActions actions={actionsDelete} message={t('confirm')} />
          </form>
        </Box>
      </Modal>
    </Grid>
  )
}
